import { render, staticRenderFns } from "./currentScore.vue?vue&type=template&id=6bdb7ee1&scoped=true&"
import script from "./currentScore.vue?vue&type=script&lang=js&"
export * from "./currentScore.vue?vue&type=script&lang=js&"
import style0 from "./currentScore.vue?vue&type=style&index=0&id=6bdb7ee1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdb7ee1",
  null
  
)

export default component.exports